"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _grid = _interopRequireDefault(require("@atlaskit/icon/core/grid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorTableIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
}, props, {
  newIcon: _grid.default
}));
EditorTableIcon.displayName = 'EditorTableIcon';
var _default = exports.default = EditorTableIcon;